import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {}
  title = 'HeartCare';

  // Check if user is logged
  // if Yes then redirect to dashboard
  ngOnInit(): void {
    // if (this.authService.getIsAuth()) {
    //   this.router.navigate(['/dashboard']);
    // }
  }
}
